var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGrid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#292D32",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22H7.81C4.17 22 2 19.83 2 16.19v-3.44h9.25V22zM22 11.25h-9.25V2h3.44C19.83 2 22 4.17 22 7.81v3.44zM11.25 11.25H2V7.81C2 4.17 4.17 2 7.81 2h3.44v9.25zM22 16.19c0 3.64-2.17 5.81-5.81 5.81h-3.44v-9.25H22v3.44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGrid2);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-2.21eb5807eab7403a3b72a367514a62f5.svg";
export { ForwardRef as ReactComponent };